module.exports = __webpack_public_path__ + "summernote.6286ad0a74aea27acf0c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/summernote/0.8.9/font/summernote.woff?e557617934c52ea068954af79ed7c221
// module id = 1260
// module chunks = 8